const Search = () => import ('@/views/search/search');
const SearchDetail = () => import ('@/views/search/detail/search-detail');


const home = {
	path: '/',
	name: 'home',
//	meta: {keepAlive: true},
	component: () => import(`@/views/home/home`),
  redirect: '/home/index',
	children: [{
    path: 'home',
    component: () => import ('@/views/home/home'),
    children:[
      {
        path: 'index',
        name: 'home',
        component: () => import ('@/views/home/index.vue'),
        meta: {
          refresh:{
            unforcedList:[]
          },

        }
      },
      {
        path: 'class_details',
        name: 'class_details',
        component: () => import ('@/views/home/class_details.vue'),
        meta: {
          timeBar: true,
          // tabBar: false
        }
      },
      {
        path: 's_distribute',
        name: 's_distribute',
        component: () => import ('@/views/home/s_distribute.vue'),
      },
      {
        path: 'jx_intro',
        name: 'jx_intro',
        component: () => import ('@/views/home/jx_intro.vue'),
        meta: {tabBar: false}
      },
      {
        path: 'jx_quanyi',
        name: 'jx_quanyi',
        component: () => import ('@/views/home/jx_quanyi.vue'),
        meta: {tabBar: false}
      },{
        path: 'xfgongchen',
        name: 'xfgongchen',
        component: () => import ('@/views/home/xfgongchen.vue'),
        meta: {tabBar: false}
      },
    ]
  },{
    path: 'sign',
    name: 'sign',
    component: () => import ('@/views/sign/sign.vue'),
    meta: {
      tabBar: false,
      useKeepAlive:'false'
    }
  },{
		//地图选址
    path: 'selectAddress',
    component: () => import ('@/views/home/selectAddress.vue'),
    meta: {tabBar: false}
  },{
    //选择选址
    path: 'searchAddress',
    component: () => import ('@/views/home/searchAddress.vue'),
    meta: {tabBar: false}
  },{
    //地图导航
    path: 'driveMap',
    component: () => import ('@/views/home/driveMap.vue'),
    meta: {tabBar: false}
  }, {
			path: 'search',
			name: 'search',
			component: () => import ('@/views/search/search'),
			meta: {tabBar: false},
			children: [{
				path: 'detail/:article_id',
				name: 'search-detail',
				component: SearchDetail,
				meta: {tabBar: false}
			}]
		},{
    //学分说明
    path: 'xf-explain',
    component: () => import ('@/views/home/xf-explain.vue'),
    //meta: {tabBar: false}
    }
	]
};

export default home;